import {
    GET_COMPANY,
    GET_LOCATION,
    GET_FOREMAN,
    GET_WORKJOB,
    GET_SHIFT
} from '../actions/UtilsActions'

const initialState = {
    locations: [],
    foremen: [],
    companies: [],
    workjobs: [],
    shifts:[]
}

const UtilsReducer = function (state = initialState, action) {
    switch (action.type) {
        case GET_COMPANY: {
            return {
                ...state,
                companies: action.payload,
            }
        }
        case GET_FOREMAN: {
            return {
                ...state,
                foremen: action.payload,
            }
        }
        case GET_LOCATION: {
            return {
                ...state,
                locations: action.payload,
            }
        }
        case GET_WORKJOB: {
            return {
                ...state,
                workjobs: action.payload,
            }
        }
        case GET_SHIFT: {
            return {
                ...state,
                shifts: action.payload,
            }
        }
        default: {
            return state
        }
    }
}

export default UtilsReducer
